/**
 * Formats the given area as text with a proper suffix.
 *
 * @param {string|number} val
 * @return {string}
 */
export default (val: string | number): string => `${val} m²`;
